/* istanbul ignore file */
import { isEmpty } from "lodash";
import { Flex, Button, P, Modal } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const WorkspaceStyle = styled.code`
  font-family: monospace;
  font-size: 1em;
  font-weight: normal;
  background-color: #f0f0f0;
  padding: 0.2em 0.4em;
  margin: 0.2em 0;
`;

const MarkActiveConfirmationDialog = ({
  onConfirm,
  onClose,
  currentActiveWorkspace,
  chosenActiveWorkspace,
}) => {
  const modalFooter = (
    <Flex mt="r">
      <Button variant="danger" onClick={onConfirm}>
        Yes, switch the active workspace
      </Button>
      <Button variant="ghost" onClick={onClose} ml="r">
        Cancel
      </Button>
    </Flex>
  );

  const haveActive = !isEmpty(currentActiveWorkspace);
  const activeName = currentActiveWorkspace?.name ?? "(NO ACTIVE WORKSPACE)";
  const activeId = currentActiveWorkspace?.id;
  const from = `${activeName}${haveActive ? ` (${activeId})` : ""}`;
  const to = `${chosenActiveWorkspace.name} (${chosenActiveWorkspace.id})`;

  return (
    <Modal
      visible={true}
      handleOnConfirm={onConfirm}
      onClose={onClose}
      footerContent={modalFooter}
      width="50vw"
      height="40vh"
      maxHeight="90vh"
      maxWidth="90vw"
    >
      <P weight="bold" fontSize={3} mb="s">
        This will change the default workspace from:
      </P>
      <WorkspaceStyle>{from}</WorkspaceStyle>
      <P weight="bold" fontSize={3} my="s">
        To:
      </P>
      <WorkspaceStyle>{to}</WorkspaceStyle>
      <P mt="xl" fontSize={3}>
        Changing the default workspace is rarely done, please confirm your
        intent.
      </P>
      <P mt="r" fontSize={3}>
        Please note:
      </P>
      <P mt="r" fontSize={3}>
        - Workspace will become available to all users regardless of workspace
        access rules. Any restriction to ADMIN users or the allow list will be
        ignored.
      </P>
      <P mt="r" fontSize={3}>
        - Reporting will automatically switch to the default workspace for the
        -user datasource. This may impact existing queries if they rely on data
        from the previous default workspace.
      </P>
      <P mt="r" fontSize={3}>
        - Users who have saved links to particular teams, people or tags may
        no-longer work and will receive 404 errors if they try the saved links
      </P>
    </Modal>
  );
};

MarkActiveConfirmationDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  currentActiveWorkspace: PropTypes.object.isRequired,
  chosenActiveWorkspace: PropTypes.object.isRequired,
};

export default MarkActiveConfirmationDialog;
